import { renderInDocument } from '@spotahome/soyuz/client';

import Location from './Location';

renderInDocument(Location);
